import * as React from 'react';
import { useState, useEffect } from "react";
import axios from 'axios';
import Sidebar from '../components/sidebar'
import Footer from '../components/footer'
import Head from '../components/head'

export default function Main() {
  const [q, setQ] = useState('')
  const [ans, setAns] = useState('')
  const [sort, setSort] = useState('0')
  const [status, setStatus] = useState('1')
  const [home, setHome] = useState(false)

  const id = new URLSearchParams(window.location.search).get("id")

  useEffect(() => {
    getbyid();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getbyid = async () => {
    const data = new FormData();
    data.append('id', id);
    axios({
      method: 'post',
      url: '/api/faq/get_byid.php',
      data: data,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(s => {
        if (!s.data.length) return
        setQ(s.data[0].q)
        setAns(s.data[0].ans)
        setSort(String(s.data[0].sort))
        setStatus(String(s.data[0].status))
        setHome(String(s.data[0].home) === '1')
      })
      .catch(s => {
        console.log('here catch =>>', s);
      });
  };

  const getDb = async () => {
    if (q.trim() === '' || ans.trim() === '') {
      alert("Question aur Answer dono zaroori hain.")
      return
    }
    const data = new FormData();
    data.append('id', id);
    data.append('q', q);
    data.append('ans', ans);
    data.append('sort', sort);
    data.append('status', status);
    data.append('home', home ? '1' : '0');
    axios({
      method: 'post',
      url: '/api/faq/update.php',
      data: data,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(s => {
        if (s.data[0].msg === "pass") {
          alert("Updated.")
        } else {
          alert("Not update try again !")
        }
      })
      .catch(s => {
        console.log('here catch =>>', s);
      });
  };

  return (
    <>
      <div className="main-wrapper">
        <Sidebar />
        <div className="page-wrapper">
          <Head />
          <div>
            <div className="page-content">
              <div className="row">
                <div className="col-md-12 grid-margin stretch-card">
                  <div className="card modern-card">
                    <div className="card-header bg-gradient-primary text-white py-4">
                      <div className="d-flex align-items-center">
                        <div>
                          <h4 className="mb-1">Update FAQ</h4>
                          <span className="opacity-75">Editing FAQ #{id}</span>
                        </div>
                        <span className="badge bg-light text-dark ms-auto py-2 px-3">Edit Mode</span>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-lg-12 mb-3 fw-bold">
                          <label className="form-label">Question</label>
                          <input type="text" className="form-control" autoComplete="off"
                            value={q} onChange={(v) => setQ(v.target.value)} />
                        </div>
                        <div className="col-lg-12 mb-3 fw-bold">
                          <label className="form-label">Answer</label>
                          <textarea className="form-control" rows="5"
                            value={ans} onChange={(v) => setAns(v.target.value)}></textarea>
                        </div>
                        <div className="col-lg-6 mb-3 fw-bold">
                          <label className="form-label">Sort Order (chhota number pehle)</label>
                          <input type="number" className="form-control"
                            value={sort} onChange={(v) => setSort(v.target.value)} />
                        </div>
                        <div className="col-lg-6 mb-3 fw-bold">
                          <label className="form-label">Status</label>
                          <select className="form-control" value={status} onChange={(v) => setStatus(v.target.value)}>
                            <option value="1">Active</option>
                            <option value="0">Inactive</option>
                          </select>
                        </div>
                        <div className="col-lg-12 mb-3">
                          <div className="form-check">
                            <input type="checkbox" className="form-check-input" id="showHome"
                              checked={home} onChange={(v) => setHome(v.target.checked)} />
                            <label className="form-check-label fw-bold" htmlFor="showHome">
                              Show on Home Page
                            </label>
                          </div>
                        </div>
                        <div className="col-lg-12 d-flex justify-content-end mt-4">
                          <a href="viewfaq" className="btn btn-light px-4 me-2">Back</a>
                          <button className="btn btn-primary px-4" onClick={() => { getDb(); }}>
                            Update FAQ
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  )
}
